/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase2_AuditInputs */

const en_directory_submit_enrich_phase2_audit = /** @type {(inputs: Directory_Submit_Enrich_Phase2_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality audit`)
};

const zh_directory_submit_enrich_phase2_audit = /** @type {(inputs: Directory_Submit_Enrich_Phase2_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量审计`)
};

/**
* | output |
* | --- |
* | "Quality audit" |
*
* @param {Directory_Submit_Enrich_Phase2_AuditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase2_audit = /** @type {((inputs?: Directory_Submit_Enrich_Phase2_AuditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase2_AuditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase2_audit(inputs)
	return zh_directory_submit_enrich_phase2_audit(inputs)
});
export { directory_submit_enrich_phase2_audit as "directory.submit.enrich.phase2.audit" }